import React from "react";
import AddPlayerCodeModal from "./AddPlayerCodeModal";
import RosterManagerModal from "../../ForBusiness/CoachDashboard/RosterManagerModal";
import { rosterForManager, teamNameOf } from "./coachUtils";

// The roster actions of a Coach Mode page header: the team code modal
// ("Team Code", or "Invite someone" with `codeTitle`), showing the code of
// `team` (one code per team), and the Roster Manager for `team`
// (activeTeamOf(selection)). `modal` is "code", "roster" or null. Kept out
// of coachPieces.js because both modals call the API, and the pieces are
// shared with Rep Mode. The Roster Manager names the team by the one
// display rule ("Manage roster · Oakland Soldiers 16U", D15); its teamName
// is display only, identity stays on teamId and league.
const RosterModals = ({ modal, onClose, team, players, onChanged, codeTitle }) => (
  <>
    <AddPlayerCodeModal open={modal === "code"} onClose={onClose} team={team} title={codeTitle} />
    <RosterManagerModal
      open={modal === "roster"}
      onClose={onClose}
      teamId={team?.teamId}
      league={team?.league || ""}
      teamName={teamNameOf(team)}
      roster={rosterForManager(players)}
      onChanged={onChanged}
    />
  </>
);

export default RosterModals;
